export class FilterHandler {
  public static serializeRouterParams(params: Object): Object {
    const serialized_params: Object = {};
    const properties = Object.getOwnPropertyNames(params);

    for (const index of properties) {
      if (params[index] !== undefined && params[index] !== null) {
        if (Array.isArray(params[index])) {
          let ids = '';
          let i = 1;
          for (const param of params[index]) {
            ids += param['id'] || param;
            if (i < params[index].length) {
              ids += ',';
            }
            serialized_params[index] = params[index].map((item) => item['id'] || item);
            i++;
          }
          /* serialized_params[index] = ids; */
        } else {
          serialized_params[index] = params[index];
        }
      }
    }

    return serialized_params;
  }

  constructor() {}

  public reset() {
    const properties = Object.getOwnPropertyNames(this);
    for (const key of properties) {
      if (this.hasOwnProperty(key)) {
        this[key] = '';
      }
    }
  }

  public serializeQueryParams(params): string {
    let string_params = '';
    for (const key in params) {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        if (Array.isArray(params[key])) {
          for (const item of params[key]) {
            const value = item['id'] || item;
            string_params += `${key}=${encodeURIComponent(value)}&`;
          }
        } else if (typeof params[key] === 'string' && params[key].includes(',')) {
          const items = params[key].split(',');
          for (const item of items) {
            string_params += `${key}=${encodeURIComponent(item)}&`;
          }
        } else {
          string_params += `${key}=${encodeURIComponent(params[key])}&`;
        }
      }
    }
    return string_params;
  }

  public unSerializedRouterParams(params: Object) {
    for (const key in params) {
      if (this.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null) {
        if (this[key] instanceof Array) {
          const ids: string[] = params[key].split(',');
          for (const id of ids) {
            this[key].push(parseInt(id, 10));
          }
        } else {
          this[key] = params[key];
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/filter-handler.ts